export default {"src":"/_next/static/media/carwash-fill.36c88e10.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};